<div class="headerdiv">
    <div>
      <h3 class="pagetitle">Manage Packages</h3>
      <label class="settings"><a>Settings</a> | <a>Analytics</a> </label>
    </div>
  
  </div>


  <mat-card class="addadmin">
    <label class="inviteuser">Add Package</label>
<div class="row">
    <div class="col d-flex justify-content-center">
      <mat-form-field [formGroup]="packageForm" appearance="outline">
          <input matInput placeholder="Name" formControlName="name">
        </mat-form-field>
    </div>
</div>
<div class="row">
    <div class="col d-flex justify-content-center">
      <mat-form-field [formGroup]="packageForm" appearance="outline">
          <input (keypress)="numberOnly($event)" type="text" matInput placeholder="Days" formControlName="days">
        </mat-form-field>
    </div>
</div>
<div class="row">
    <div class="col d-flex justify-content-center">
      <mat-form-field [formGroup]="packageForm" appearance="outline">
          <input (keypress)="numberOnly($event)" type="text" onlyNumber matInput placeholder="Cost" formControlName="cost">
        </mat-form-field>
    </div>
</div>
<button (click)="submitPackage()" mat-flat-button color="primary">Create</button>
</mat-card>
  
    <div style="padding: 30px">
    <div class="row">
        <div class="pendingeventdiv" *ngFor="let el of packages; let i=index">
          <p class="eventtitle"><input [(ngModel)]="packages[i].name" [disabled]="packages[i].showMore" matInput value={{packages[i].name}}/></p>
         
          <div class="row">
            <div class="col option1">
              # Days
            </div>
            <div class="col">
                <input [(ngModel)]="packages[i].days" [disabled]="packages[i].showMore" (keypress)="numberOnly($event)" matInput value={{packages[i].days}}/>
            </div>
          </div>
          <div class="row">
            <div class="col option1">
              Cost
            </div>
            <div class="col">
                <input [(ngModel)]="packages[i].cost" [disabled]="packages[i].showMore" (keypress)="numberOnly($event)" matInput value={{packages[i].cost}}/>
            </div>
          </div>
          
        
          <div class="row divfooter">
            <div class="col">
              <mat-icon [hidden]="!packages[i].showMore" (click)="change(packages[i].id)" class="accept">create</mat-icon>
              
            </div>

            <div class="col">
                <mat-icon [hidden]="packages[i].showMore" (click)="editPackage(packages[i])" class="accept">done</mat-icon>
                
              </div>
            <div class="col">
              <mat-icon (click)="showCancellation(packages[i].id)" class="reject">close</mat-icon>
            </div>
          </div>
        </div> 
      </div>

      <!-- Cancellation Reason Modal -->
  
  <div [style.display]="cancellationReason ? 'block' : 'none'" class="modal" id="imagemodal" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel">Delete Package</h4>
        <i style="cursor: pointer;" style="transform: scale(2);" data-dismiss="modal" (click)="hideCancellation()"
          class="material-icons">highlight_off</i>

      </div>
      <div style="display: inline-block;">

        <div class="modal-body">
         
          <mat-label>Are you sure you want to delete this package?</mat-label>

          <button (click)="deleteAd()" class="confirmcancellation">Confirm Rejection</button>
        </div>
        <div class="modal-footer">

        </div>
      </div>
    </div>
  </div>
</div>
  
  
 
  